var render, staticRenderFns
import script from "./enableForm.vue?vue&type=script&lang=js"
export * from "./enableForm.vue?vue&type=script&lang=js"
import style0 from "./enableForm.vue?vue&type=style&index=0&id=67d1b0aa&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d1b0aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67d1b0aa')) {
      api.createRecord('67d1b0aa', component.options)
    } else {
      api.reload('67d1b0aa', component.options)
    }
    
  }
}
component.options.__file = "found/views/tpm/views/fee_regular/fee_rule_report/form/enableForm.vue"
export default component.exports